<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
      <template v-if="userData.data.company_id && userData.data.company_id !== 3">
        <b-col
          cols="12"
          md="4"
          class="mb-md-0"
        >
          <v-select
            id="v-Project"
            v-model="select_project"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="ProjectOptions"
            :reduce="(ProjectOptions) => ProjectOptions.value"
            label="title"
            placeholder="--Select Project --"
            class="w-100"
            @input="change_project()"
          />
        </b-col>
      </template>
      <!-- <b class="ml-5">{{ datenow }}</b> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.fullName || userData.username }}
            </p>
            <span class="user-status">{{ userData.role }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="userData.avatar"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <b-dropdown-item
          :to="{ name: 'profile'}"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>
        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

import {
  BLink, BCol, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
// import { initialAbility } from '@/libs/acl/config'

const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")

export default {
  components: {
    vSelect,
    BLink,
    BCol,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    Locale,
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      select_project: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
    }
  },
  computed: {
    ...mapState({
      ProjectOptions: state => state.user.ProjectOptions,
    }),
  },
  created() {
    this.select_project = this.userData.data.user_projects[0]?.project_id
    this.$store.dispatch('user/getProject')
    setInterval(() => this.updateCurrentTime(), 1000)
  },
  // watch: {
  //   select_project() {
  //     return this.change_project()
  //   }
  // },
  methods: {
    updateCurrentTime() {
      this.datenow = getCurrentTime()
    },
    logout() {
      const sso = process.env.VUE_APP_USING_SSO === 'true'
      if (!sso) {
        // Remove userData from localStorage
        // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

        // Remove userData from localStorage
        localStorage.removeItem('userData')

        // Reset ability
        this.$ability.update(initialAbility)

        // Redirect to login page
        this.$router.push({ name: 'auth-login' })
      } else {
        const { host, protocol } = window.location
        const baseUrl = process.env.VUE_APP_USER_API
        const clientId = process.env.VUE_APP_CLIENT_ID
        const clientSecret = process.env.VUE_APP_CLIENT_SECRET
        const redirectUri = `${protocol}//${host}`
        const authorizeUrl = `${baseUrl}/internal/oauth/logout?client_id=${clientId}&client_secret=${clientSecret}&redirect_uri=${encodeURIComponent(redirectUri)}`
        window.location.replace(authorizeUrl)
      }
    },
    change_project() {
      this.$store.dispatch('user/setProject', this.select_project).then(res => {
        useJwt.getProfile().then(response => {
          // if (response.data.data.email === 'client-cold-chain-admin@universal-iot.com') {
          //   this.role = 'AdministratorTemperature'
          // } else if (response.data.data.email === 'client-cold-chain-user@universal-iot.com') {
          //   this.role = 'AdministratorTemperature'
          // } else if (response.data.data.email === 'client-sparing-admin@universal-iot.com') {
          //   this.role = 'AdministratorSparing'
          // } else if (response.data.data.email === 'client-sparing-user@universal-iot.com') {
          //   this.role = 'AdministratorSparing'
          // } else {
          //   this.role = 'Administrator'
          // }
          const userData = {
            id: response.data.data.id,
            fullName: response.data.data.name,
            username: response.data.data.name,
            password: '',
            avatar: response.data.data.photo,
            email: response.data.data.email,
            data: response.data.data,
            role: this.role,
            ability: [
              {
                action: 'manage',
                subject: 'all',
              },
            ],
          }
          localStorage.setItem('sesnotify', 'on')
          localStorage.setItem('userData', JSON.stringify(userData))
          this.$ability.update(userData.ability)
          this.$router.go(0)
        })
      })
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
